"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalStatus = void 0;

var _modalstatus = require("../actions/modalstatus");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// actions

/* ========== ~~~~~~~~~~ MODAL STATUS : REDUCER ~~~~~~~~~~ ========== */


var defaultState = {
  visible: false,
  content: null,
  showCloseButton: true
}; // REDUCER

var modalStatus = function modalStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _modalstatus.DISPLAY_MODAL:
      //let newState = JSON.parse(JSON.stringify(state));
      var newState = Object.assign({}, state);

      if (action.showCloseButton === undefined) {
        action.showCloseButton = true;
      }

      var updatedState = Object.assign({}, newState, {
        visible: action.isVisible,
        showCloseButton: action.showCloseButton,
        content: action.contentToDisplay
      });
      return Object.assign({}, newState, updatedState);

    case "CLEAR_ALL_STATES":
      return defaultState;

    default:
      return state;
  }
};

exports.modalStatus = modalStatus;